exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb {\r\n    background-color: #3eb049;\r\n}\r\n\r\n::ng-deep .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar {\r\n    background-color: #56c040;\r\n}\r\n\r\n::ng-deep .mat-slide-toggle .mat-ripple-element {\r\n  background-color:rgba(102, 255, 64, 0.26)\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar-edit/calendar-edit.component.css
// module id = ../../../../../src/app/calendar/calendar-edit/calendar-edit.component.css
// module chunks = main